var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("edit")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click() {
        return _vm.close();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', [_c('v-form', {
    model: {
      value: _vm.isEditValid,
      callback: function callback($$v) {
        _vm.isEditValid = $$v;
      },
      expression: "isEditValid"
    }
  }, [_c('rental-form', {
    attrs: {
      "showCompany": false
    },
    scopedSlots: _vm._u([{
      key: "fileUpload",
      fn: function fn() {
        return [_c('drop-area-multi', {
          staticClass: "mb-4",
          attrs: {
            "files": _vm.files,
            "loading": _vm.isLoading,
            "accept": ".pdf",
            "maxFiles": 1
          },
          on: {
            "update:files": function updateFiles($event) {
              _vm.files = $event;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.editRental,
      callback: function callback($$v) {
        _vm.editRental = $$v;
      },
      expression: "editRental"
    }
  })], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.isLoading,
      "disabled": !_vm.isEditValid
    },
    on: {
      "click": function click() {
        return _vm.update();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }